import React from "react";
import {
  FaReact,
} from "react-icons/fa";
import { SiNextdotjs, SiNodedotjs } from "react-icons/si";
import Title from "../layouts/Title";
import Card from "./Card";
const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] dark:border-b-gray-600"
    >
      <Title title="Features" des="What I Do" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="React.Js"
          des=" I am highly skilled in React.js and have used it extensively to build user interfaces and single-page applications. I have experience with Redux, React Router, and other popular React libraries and tools."
          icon={<FaReact />}
        />
        <Card
          title="Next.Js"
          des=" I have worked with Next.js to build server-side rendered React applications, providing efficient rendering, server-side rendering, API handling, and other useful features."
          icon={<SiNextdotjs />}
        />
        <Card
          title="Node.Js"
          des="I am experienced with Node.js, a runtime environment for executing JavaScript on the server-side. It enables building scalable and efficient server applications, handling I/O operations, and creating RESTful APIs."
          icon={<SiNodedotjs />}
        />
      </div>
    </section>
  );
};

export default Features;